module.exports = __webpack_public_path__ + "img/M007-17_jrb-03.751a097d.jpg";